import BaseApiAction from "@Actions/base-api-action";

export default class PaymentMethods extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "stripe-paymentMethods",
      payload: {
        user_id: this._payload.userId,
        ...this.addFieldIfExists("limit", this._payload.limit),
        ...this.addFieldIfExists("add", this._payload.add),
        ...this.addFieldIfExists("delete_pm", this._payload.delete),
        ...this.addFieldIfExists("subscription_id", this._payload.subscriptionId),
      },
    });
  }

  onSuccess(data: any) {
    super.onSuccess(data);
  }
}
